/*
 * Warranty add-ons
 * ----------------
 * Lets a customer tick one or more warranty / protection-plan products that are
 * shown on a product page (rendered by snippets/product-warranty-addons.liquid)
 * and have them added to the cart as separate line items in the SAME click as
 * the main product.
 *
 * How it hooks in without fighting product-form.js:
 *   We listen for "submit" on `document` in the CAPTURE phase. Capture-phase
 *   listeners on an ancestor run BEFORE the target form's own (bubble-phase)
 *   listener that product-form.js attaches. So when at least one warranty is
 *   ticked we can stopImmediatePropagation() to take over; when none are ticked
 *   we do nothing and the theme's normal single-item add runs untouched.
 */
(function () {
    if (window.__warrantyAddonsBound) return;
    window.__warrantyAddonsBound = true;

    function getCheckedWarranties() {
        // add-on checkboxes now live in their own section below the product info,
        // so scan the whole document. We only ever call this for the MAIN product
        // form (see the .product__info guard in the submit handler), so the FBT
        // form below won't accidentally pull these in.
        return Array.from(document.querySelectorAll(".js-addon-variant:checked"));
    }

    function setLoading(button, loading) {
        if (!button) return;
        if (loading) {
            if (
                !button.querySelector(".loading-overlay") &&
                typeof createFromTemplate === "function"
            ) {
                button.prepend(createFromTemplate("template-loading-overlay"));
            }
            button.setAttribute("aria-disabled", true);
            button.classList.add("loading");
        } else {
            button.classList.remove("loading");
            button.removeAttribute("aria-disabled");
        }
    }

    function buildBody(items, cart) {
        const formData = new FormData();
        items.forEach((item, i) => {
            formData.append(`items[${i}][id]`, item.id);
            formData.append(`items[${i}][quantity]`, item.quantity);
        });
        if (cart && cart.getSectionsToRender) {
            formData.append(
                "sections",
                cart.getSectionsToRender().map((s) => s.id)
            );
            formData.append("sections_url", window.location.pathname);
        }
        return formData;
    }

    function postAdd(body) {
        const config =
            typeof fetchConfig === "function"
                ? fetchConfig("javascript")
                : { method: "POST", headers: {} };
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = body;
        return fetch(routes.cart_add_url, config).then((r) => r.json());
    }

    document.addEventListener(
        "submit",
        function (evt) {
            const form = evt.target;
            if (
                !form ||
                !form.matches ||
                !form.matches('form[data-type="add-to-cart-form"]')
            ) {
                return;
            }

            // Only the MAIN product form bundles add-ons. The "Frequently Bought
            // Together" form is also a [data-type=add-to-cart-form] but sits
            // outside .product__info, so it keeps its own behaviour.
            if (!form.closest(".product__info")) return;

            const checked = getCheckedWarranties();
            if (checked.length === 0) return; // let product-form.js handle it

            const cart = document.querySelector("cart-sidebar");
            if (!cart) return; // no AJAX cart -> fall back to native submit

            // We're taking over: stop the theme's own submit handler.
            evt.preventDefault();
            evt.stopImmediatePropagation();

            const submitButton =
                form.querySelector('[type="submit"]') ||
                document.querySelector('[form="' + form.id + '"]');
            if (submitButton && submitButton.classList.contains("loading"))
                return;
            setLoading(submitButton, true);

            const idInput = form.querySelector('[name="id"]');
            const qtyInput = form.querySelector('[name="quantity"]');
            const mainId = idInput && idInput.value;
            const mainQty = (qtyInput && qtyInput.value) || 1;

            const items = [{ id: mainId, quantity: mainQty }];
            checked.forEach((cb) =>
                items.push({ id: cb.value, quantity: 1 })
            );

            cart.setActiveElement &&
                cart.setActiveElement(document.activeElement);

            postAdd(buildBody(items, cart))
                .then((response) => {
                    if (response.status) {
                        // Adding the bundle failed (e.g. a warranty went out of
                        // stock). Don't block the sale: add just the main item.
                        return postAdd(
                            buildBody(
                                [{ id: mainId, quantity: mainQty }],
                                cart
                            )
                        );
                    }
                    return response;
                })
                .then((response) => {
                    if (!response) return;
                    if (response.status) {
                        window.location.reload();
                        return;
                    }
                    if (response.sections) {
                        cart.renderContents(response);
                        checked.forEach((cb) => (cb.checked = false));
                    } else {
                        window.location.reload();
                    }
                })
                .catch((e) => {
                    console.error("warranty-addons:", e);
                    window.location.reload();
                })
                .finally(() => setLoading(submitButton, false));
        },
        true // capture phase -> runs before product-form.js
    );
})();
